import { takeLatest, all, select } from 'redux-saga/effects';
import { PRINT_QUOTATION } from './constants';
import { makeSelectQuotationCode } from './selectors-sidebar';
import { getRequestHeadersAsLogged } from '../../utils/auth';

function* printQuote() {
  const code = yield select(makeSelectQuotationCode());
  const requestURL = `${process.env.API_URL}proposals/${code}/attachment`;
  try {
    const parameters = {
      method: 'POST',
      headers: getRequestHeadersAsLogged(),
    };

    yield fetch(requestURL, parameters)
      .then(response => response.blob())
      .then(blob => {
        const date = new Date();
        return download(blob, `Preventivo-${date.getTime()}`);
      });
  } catch (err) {
    console.log('request error', err);
  }
}

function* actionWatcher() {
  yield takeLatest(PRINT_QUOTATION, printQuote);
}

export default function* quotationData() {
  yield all([actionWatcher()]);
}
